(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __reExport = (target, module, desc) => {
    if (module && typeof module === "object" || typeof module === "function") {
      for (let key2 of __getOwnPropNames(module))
        if (!__hasOwnProp.call(target, key2) && key2 !== "default")
          __defProp(target, key2, { get: () => module[key2], enumerable: !(desc = __getOwnPropDesc(module, key2)) || desc.enumerable });
    }
    return target;
  };
  var __toModule = (module) => {
    return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", module && module.__esModule && "default" in module ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
  };

  // node_modules/easytimer.js/dist/easytimer.js
  var require_easytimer = __commonJS({
    "node_modules/easytimer.js/dist/easytimer.js"(exports, module) {
      (function(global, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.easytimer = {}));
      })(exports, function(exports2) {
        "use strict";
        function _typeof(obj) {
          "@babel/helpers - typeof";
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function(obj2) {
              return typeof obj2;
            };
          } else {
            _typeof = function(obj2) {
              return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            };
          }
          return _typeof(obj);
        }
        function _defineProperty(obj, key2, value) {
          if (key2 in obj) {
            Object.defineProperty(obj, key2, {
              value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key2] = value;
          }
          return obj;
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly)
              symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              });
            keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
              ownKeys(Object(source), true).forEach(function(key2) {
                _defineProperty(target, key2, source[key2]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function(key2) {
                Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
              });
            }
          }
          return target;
        }
        function leftPadding(string, padLength, character) {
          var i;
          var characters = "";
          string = typeof string === "number" ? String(string) : string;
          if (string.length > padLength) {
            return string;
          }
          for (i = 0; i < padLength; i = i + 1) {
            characters += String(character);
          }
          return (characters + string).slice(-characters.length);
        }
        function TimeCounter() {
          this.reset();
        }
        TimeCounter.prototype.toString = function() {
          var units = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["hours", "minutes", "seconds"];
          var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ":";
          var leftZeroPadding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
          units = units || ["hours", "minutes", "seconds"];
          separator = separator || ":";
          leftZeroPadding = leftZeroPadding || 2;
          var arrayTime = [];
          var i;
          for (i = 0; i < units.length; i = i + 1) {
            if (this[units[i]] !== void 0) {
              if (units[i] === "secondTenths") {
                arrayTime.push(this[units[i]]);
              } else {
                arrayTime.push(leftPadding(this[units[i]], leftZeroPadding, "0"));
              }
            }
          }
          return arrayTime.join(separator);
        };
        TimeCounter.prototype.reset = function() {
          this.secondTenths = 0;
          this.seconds = 0;
          this.minutes = 0;
          this.hours = 0;
          this.days = 0;
        };
        function EventEmitter() {
          this.events = {};
        }
        EventEmitter.prototype.on = function(event, listener) {
          var _this = this;
          if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
          }
          this.events[event].push(listener);
          return function() {
            return _this.removeListener(event, listener);
          };
        };
        EventEmitter.prototype.removeListener = function(event, listener) {
          if (Array.isArray(this.events[event])) {
            var eventIndex = this.events[event].indexOf(listener);
            if (eventIndex > -1) {
              this.events[event].splice(eventIndex, 1);
            }
          }
        };
        EventEmitter.prototype.emit = function(event) {
          var _this2 = this;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          if (Array.isArray(this.events[event])) {
            this.events[event].forEach(function(listener) {
              return listener.apply(_this2, args);
            });
          }
        };
        var SECOND_TENTHS_PER_SECOND = 10;
        var SECONDS_PER_MINUTE = 60;
        var MINUTES_PER_HOUR = 60;
        var HOURS_PER_DAY = 24;
        var SECOND_TENTHS_POSITION = 0;
        var SECONDS_POSITION = 1;
        var MINUTES_POSITION = 2;
        var HOURS_POSITION = 3;
        var DAYS_POSITION = 4;
        var SECOND_TENTHS = "secondTenths";
        var SECONDS = "seconds";
        var MINUTES = "minutes";
        var HOURS = "hours";
        var DAYS = "days";
        var VALID_INPUT_VALUES = [SECOND_TENTHS, SECONDS, MINUTES, HOURS, DAYS];
        var unitsInMilliseconds = {
          secondTenths: 100,
          seconds: 1e3,
          minutes: 6e4,
          hours: 36e5,
          days: 864e5
        };
        var groupedUnits = {
          secondTenths: SECOND_TENTHS_PER_SECOND,
          seconds: SECONDS_PER_MINUTE,
          minutes: MINUTES_PER_HOUR,
          hours: HOURS_PER_DAY
        };
        function mod(number, module2) {
          return (number % module2 + module2) % module2;
        }
        function Timer2() {
          var defaultParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          var counters = new TimeCounter();
          var totalCounters = new TimeCounter();
          var intervalId;
          var eventEmitter = new EventEmitter();
          var running = false;
          var paused = false;
          var precision;
          var timerTypeFactor;
          var customCallback;
          var timerConfig = {};
          var currentParams;
          var targetValues;
          var startValues;
          var countdown;
          var startingDate;
          var targetDate;
          var eventData = {
            detail: {
              timer: this
            }
          };
          setParams(defaultParams);
          function updateCounters(precision2, roundedValue) {
            var unitsPerGroup = groupedUnits[precision2];
            totalCounters[precision2] = roundedValue;
            if (precision2 === DAYS) {
              counters[precision2] = Math.abs(roundedValue);
            } else if (roundedValue >= 0) {
              counters[precision2] = mod(roundedValue, unitsPerGroup);
            } else {
              counters[precision2] = mod(unitsPerGroup - mod(roundedValue, unitsPerGroup), unitsPerGroup);
            }
          }
          function updateDays(value) {
            return updateUnitByPrecision(value, DAYS);
          }
          function updateHours(value) {
            return updateUnitByPrecision(value, HOURS);
          }
          function updateMinutes(value) {
            return updateUnitByPrecision(value, MINUTES);
          }
          function updateSeconds(value) {
            return updateUnitByPrecision(value, SECONDS);
          }
          function updateSecondTenths(value) {
            return updateUnitByPrecision(value, SECOND_TENTHS);
          }
          function updateUnitByPrecision(value, precision2) {
            var previousValue = totalCounters[precision2];
            updateCounters(precision2, calculateIntegerUnitQuotient(value, unitsInMilliseconds[precision2]));
            return totalCounters[precision2] !== previousValue;
          }
          function stopTimerAndResetCounters() {
            stopTimer();
            resetCounters();
          }
          function stopTimer() {
            clearInterval(intervalId);
            intervalId = void 0;
            running = false;
            paused = false;
          }
          function setParamsAndStartTimer(params) {
            if (!isPaused()) {
              setParams(params);
            } else {
              startingDate = calculateStartingDate();
              targetValues = setTarget(currentParams.target);
            }
            startTimer();
          }
          function startTimer() {
            var interval = unitsInMilliseconds[precision];
            if (isTargetAchieved(roundTimestamp(Date.now()))) {
              return;
            }
            intervalId = setInterval(updateTimerAndDispatchEvents, interval);
            running = true;
            paused = false;
          }
          function calculateStartingDate() {
            return roundTimestamp(Date.now()) - totalCounters.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
          }
          function updateTimerAndDispatchEvents() {
            var currentTime = roundTimestamp(Date.now());
            var valuesUpdated = updateTimer();
            dispatchEvents(valuesUpdated);
            customCallback(eventData.detail.timer);
            if (isTargetAchieved(currentTime)) {
              stop();
              dispatchEvent("targetAchieved", eventData);
            }
          }
          function updateTimer() {
            var currentTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : roundTimestamp(Date.now());
            var elapsedTime = timerTypeFactor > 0 ? currentTime - startingDate : startingDate - currentTime;
            var valuesUpdated = {};
            valuesUpdated[SECOND_TENTHS] = updateSecondTenths(elapsedTime);
            valuesUpdated[SECONDS] = updateSeconds(elapsedTime);
            valuesUpdated[MINUTES] = updateMinutes(elapsedTime);
            valuesUpdated[HOURS] = updateHours(elapsedTime);
            valuesUpdated[DAYS] = updateDays(elapsedTime);
            return valuesUpdated;
          }
          function roundTimestamp(timestamp) {
            return Math.floor(timestamp / unitsInMilliseconds[precision]) * unitsInMilliseconds[precision];
          }
          function dispatchEvents(valuesUpdated) {
            if (valuesUpdated[SECOND_TENTHS]) {
              dispatchEvent("secondTenthsUpdated", eventData);
            }
            if (valuesUpdated[SECONDS]) {
              dispatchEvent("secondsUpdated", eventData);
            }
            if (valuesUpdated[MINUTES]) {
              dispatchEvent("minutesUpdated", eventData);
            }
            if (valuesUpdated[HOURS]) {
              dispatchEvent("hoursUpdated", eventData);
            }
            if (valuesUpdated[DAYS]) {
              dispatchEvent("daysUpdated", eventData);
            }
          }
          function isTargetAchieved(currentDate) {
            return targetValues instanceof Array && currentDate >= targetDate;
          }
          function resetCounters() {
            counters.reset();
            totalCounters.reset();
          }
          function setParams(params) {
            params = params || {};
            precision = checkPrecision(params.precision);
            customCallback = typeof params.callback === "function" ? params.callback : function() {
            };
            countdown = params.countdown === true;
            timerTypeFactor = countdown === true ? -1 : 1;
            if (_typeof(params.startValues) === "object") {
              setStartValues(params.startValues);
            } else {
              startValues = null;
            }
            startingDate = calculateStartingDate();
            updateTimer();
            if (_typeof(params.target) === "object") {
              targetValues = setTarget(params.target);
            } else if (countdown) {
              params.target = {
                seconds: 0
              };
              targetValues = setTarget(params.target);
            } else {
              targetValues = null;
            }
            timerConfig = {
              precision,
              callback: customCallback,
              countdown: _typeof(params) === "object" && params.countdown === true,
              target: targetValues,
              startValues
            };
            currentParams = params;
          }
          function checkPrecision(precision2) {
            precision2 = typeof precision2 === "string" ? precision2 : SECONDS;
            if (!isValidInputValue(precision2)) {
              throw new Error("Error in precision parameter: ".concat(precision2, " is not a valid value"));
            }
            return precision2;
          }
          function isValidInputValue(value) {
            return VALID_INPUT_VALUES.indexOf(value) >= 0;
          }
          function configInputValues(inputValues) {
            var values;
            if (_typeof(inputValues) === "object") {
              if (inputValues instanceof Array) {
                if (inputValues.length !== 5) {
                  throw new Error("Array size not valid");
                }
                values = inputValues;
              } else {
                for (var value in inputValues) {
                  if (VALID_INPUT_VALUES.indexOf(value) < 0) {
                    throw new Error("Error in startValues or target parameter: ".concat(value, " is not a valid input value"));
                  }
                }
                values = [inputValues.secondTenths || 0, inputValues.seconds || 0, inputValues.minutes || 0, inputValues.hours || 0, inputValues.days || 0];
              }
            }
            var secondTenths = values[SECOND_TENTHS_POSITION];
            var seconds = values[SECONDS_POSITION] + calculateIntegerUnitQuotient(secondTenths, SECOND_TENTHS_PER_SECOND);
            var minutes = values[MINUTES_POSITION] + calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
            var hours = values[HOURS_POSITION] + calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
            var days = values[DAYS_POSITION] + calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
            values[SECOND_TENTHS_POSITION] = secondTenths % SECOND_TENTHS_PER_SECOND;
            values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
            values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
            values[HOURS_POSITION] = hours % HOURS_PER_DAY;
            values[DAYS_POSITION] = days;
            return values;
          }
          function calculateIntegerUnitQuotient(unit, divisor) {
            var quotient = unit / divisor;
            return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
          }
          function setTarget(inputTarget) {
            if (!inputTarget) {
              return;
            }
            targetValues = configInputValues(inputTarget);
            var targetCounter = calculateTotalCounterFromValues(targetValues);
            targetDate = startingDate + targetCounter.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
            return targetValues;
          }
          function setStartValues(inputStartValues) {
            startValues = configInputValues(inputStartValues);
            counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
            counters.seconds = startValues[SECONDS_POSITION];
            counters.minutes = startValues[MINUTES_POSITION];
            counters.hours = startValues[HOURS_POSITION];
            counters.days = startValues[DAYS_POSITION];
            totalCounters = calculateTotalCounterFromValues(startValues, totalCounters);
          }
          function calculateTotalCounterFromValues(values, outputCounter) {
            var total = outputCounter || {};
            total.days = values[DAYS_POSITION];
            total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
            total.minutes = total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
            total.seconds = total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
            total.secondTenths = total.seconds * SECOND_TENTHS_PER_SECOND + values[[SECOND_TENTHS_POSITION]];
            return total;
          }
          function stop() {
            stopTimerAndResetCounters();
            dispatchEvent("stopped", eventData);
          }
          function reset() {
            stopTimerAndResetCounters();
            setParamsAndStartTimer(currentParams);
            dispatchEvent("reset", eventData);
          }
          function start() {
            var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            params = _objectSpread2(_objectSpread2({}, defaultParams), params);
            if (isRunning()) {
              return;
            }
            setParamsAndStartTimer(params);
            dispatchEvent("started", eventData);
          }
          function pause() {
            stopTimer();
            paused = true;
            dispatchEvent("paused", eventData);
          }
          function addEventListener(eventType, listener) {
            eventEmitter.on(eventType, listener);
          }
          function removeEventListener(eventType, listener) {
            eventEmitter.removeListener(eventType, listener);
          }
          function dispatchEvent(eventType, data) {
            eventEmitter.emit(eventType, data);
          }
          function isRunning() {
            return running;
          }
          function isPaused() {
            return paused;
          }
          function getTimeValues() {
            return counters;
          }
          function getTotalTimeValues() {
            return totalCounters;
          }
          function getConfig() {
            return timerConfig;
          }
          if (typeof this !== "undefined") {
            this.start = start;
            this.pause = pause;
            this.stop = stop;
            this.reset = reset;
            this.isRunning = isRunning;
            this.isPaused = isPaused;
            this.getTimeValues = getTimeValues;
            this.getTotalTimeValues = getTotalTimeValues;
            this.getConfig = getConfig;
            this.addEventListener = addEventListener;
            this.on = addEventListener;
            this.removeEventListener = removeEventListener;
            this.off = removeEventListener;
          }
        }
        exports2.Timer = Timer2;
        exports2.default = Timer2;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/zenscroll/zenscroll.js
  var require_zenscroll = __commonJS({
    "node_modules/zenscroll/zenscroll.js"(exports, module) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory());
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          (function install() {
            if (document && document.body) {
              root.zenscroll = factory();
            } else {
              setTimeout(install, 9);
            }
          })();
        }
      })(exports, function() {
        "use strict";
        var isNativeSmoothScrollEnabledOn = function(elem) {
          return elem && "getComputedStyle" in window && window.getComputedStyle(elem)["scroll-behavior"] === "smooth";
        };
        if (typeof window === "undefined" || !("document" in window)) {
          return {};
        }
        var makeScroller = function(container, defaultDuration, edgeOffset) {
          defaultDuration = defaultDuration || 999;
          if (!edgeOffset && edgeOffset !== 0) {
            edgeOffset = 9;
          }
          var scrollTimeoutId;
          var setScrollTimeoutId = function(newValue) {
            scrollTimeoutId = newValue;
          };
          var stopScroll = function() {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
          };
          var getTopWithEdgeOffset = function(elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
          };
          var scrollToY = function(targetY, duration, onDone) {
            stopScroll();
            if (duration === 0 || duration && duration < 0 || isNativeSmoothScrollEnabledOn(container.body)) {
              container.toY(targetY);
              if (onDone) {
                onDone();
              }
            } else {
              var startY = container.getY();
              var distance = Math.max(0, targetY) - startY;
              var startTime = new Date().getTime();
              duration = duration || Math.min(Math.abs(distance), defaultDuration);
              (function loopScroll() {
                setScrollTimeoutId(setTimeout(function() {
                  var p = Math.min(1, (new Date().getTime() - startTime) / duration);
                  var y = Math.max(0, Math.floor(startY + distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)));
                  container.toY(y);
                  if (p < 1 && container.getHeight() + y < container.body.scrollHeight) {
                    loopScroll();
                  } else {
                    setTimeout(stopScroll, 99);
                    if (onDone) {
                      onDone();
                    }
                  }
                }, 9));
              })();
            }
          };
          var scrollToElem = function(elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
          };
          var scrollIntoView = function(elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (getTopWithEdgeOffset(elem) < y || elemHeight + edgeOffset > containerHeight) {
              scrollToElem(elem, duration, onDone);
            } else if (elemBottom + edgeOffset > containerBottom) {
              scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone);
            } else if (onDone) {
              onDone();
            }
          };
          var scrollToCenterOf = function(elem, duration, offset, onDone) {
            scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight() / 2 + (offset || elem.getBoundingClientRect().height / 2)), duration, onDone);
          };
          var setup = function(newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) {
              defaultDuration = newDefaultDuration;
            }
            if (newEdgeOffset === 0 || newEdgeOffset) {
              edgeOffset = newEdgeOffset;
            }
            return {
              defaultDuration,
              edgeOffset
            };
          };
          return {
            setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function() {
              return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf
          };
        };
        var docElem = document.documentElement;
        var getDocY = function() {
          return window.scrollY || docElem.scrollTop;
        };
        var zenscroll2 = makeScroller({
          body: document.scrollingElement || document.body,
          toY: function(y) {
            window.scrollTo(0, y);
          },
          getY: getDocY,
          getHeight: function() {
            return window.innerHeight || docElem.clientHeight;
          },
          getTopOf: function(elem) {
            return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop;
          }
        });
        zenscroll2.createScroller = function(scrollContainer, defaultDuration, edgeOffset) {
          return makeScroller({
            body: scrollContainer,
            toY: function(y) {
              scrollContainer.scrollTop = y;
            },
            getY: function() {
              return scrollContainer.scrollTop;
            },
            getHeight: function() {
              return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight);
            },
            getTopOf: function(elem) {
              return elem.offsetTop;
            }
          }, defaultDuration, edgeOffset);
        };
        if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {
          var isHistorySupported = "history" in window && "pushState" in history;
          var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history;
          if (isScrollRestorationSupported) {
            history.scrollRestoration = "auto";
          }
          window.addEventListener("load", function() {
            if (isScrollRestorationSupported) {
              setTimeout(function() {
                history.scrollRestoration = "manual";
              }, 9);
              window.addEventListener("popstate", function(event) {
                if (event.state && "zenscrollY" in event.state) {
                  zenscroll2.toY(event.state.zenscrollY);
                }
              }, false);
            }
            if (window.location.hash) {
              setTimeout(function() {
                var edgeOffset = zenscroll2.setup().edgeOffset;
                if (edgeOffset) {
                  var targetElem = document.getElementById(window.location.href.split("#")[1]);
                  if (targetElem) {
                    var targetY = Math.max(0, zenscroll2.getTopOf(targetElem) - edgeOffset);
                    var diff = zenscroll2.getY() - targetY;
                    if (0 <= diff && diff < 9) {
                      window.scrollTo(0, targetY);
                    }
                  }
                }
              }, 9);
            }
          }, false);
          var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
          window.addEventListener("click", function(event) {
            var anchor = event.target;
            while (anchor && anchor.tagName !== "A") {
              anchor = anchor.parentNode;
            }
            if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
              return;
            }
            if (isScrollRestorationSupported) {
              var historyState = history.state && typeof history.state === "object" ? history.state : {};
              historyState.zenscrollY = zenscroll2.getY();
              try {
                history.replaceState(historyState, "");
              } catch (e) {
              }
            }
            var href = anchor.getAttribute("href") || "";
            if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
              var targetY = 0;
              var targetElem = document.getElementById(href.substring(1));
              if (href !== "#") {
                if (!targetElem) {
                  return;
                }
                targetY = zenscroll2.getTopOf(targetElem);
              }
              event.preventDefault();
              var onDone = function() {
                window.location = href;
              };
              var edgeOffset = zenscroll2.setup().edgeOffset;
              if (edgeOffset) {
                targetY = Math.max(0, targetY - edgeOffset);
                if (isHistorySupported) {
                  onDone = function() {
                    history.pushState({}, "", href);
                  };
                }
              }
              zenscroll2.toY(targetY, null, onDone);
            }
          }, false);
        }
        return zenscroll2;
      });
    }
  });

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute.");
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError("Theme Sections: The properties object provided is not a valid");
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.container === container;
        }));
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.type === type;
        }));
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id2) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id2) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id2 + '"]');
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id2 + '"]');
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // node_modules/@shopify/theme-product-form/listeners.js
  function Listeners() {
    this.entries = [];
  }
  Listeners.prototype.add = function(element, event, fn) {
    this.entries.push({ element, event, fn });
    element.addEventListener(event, fn);
  };
  Listeners.prototype.removeAll = function() {
    this.entries = this.entries.filter(function(listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  // node_modules/@shopify/theme-product/theme-product.js
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);
    var optionArray = _createOptionArrayFromOptionCollection(product, collection);
    return getVariantFromOptionArray(product, optionArray);
  }
  function getVariantFromOptionArray(product, options2) {
    _validateProductStructure(product);
    _validateOptionsArray(options2);
    var result = product.variants.filter(function(variant) {
      return options2.every(function(option, index) {
        return variant.options[index] === option;
      });
    });
    return result[0] || null;
  }
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function(option) {
      for (var i = 0; i < product.options.length; i++) {
        if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i] = option.value;
          break;
        }
      }
    });
    return optionArray;
  }
  function _validateProductStructure(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + " is empty.");
    }
  }
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) {
      throw new TypeError(collection + " is not an array.");
    }
    if (collection.length === 0) {
      return [];
    }
    if (collection[0].hasOwnProperty("name")) {
      if (typeof collection[0].name !== "string") {
        throw new TypeError("Invalid value type passed for name of option " + collection[0].name + ". Value should be string.");
      }
    } else {
      throw new Error(collection[0] + "does not contain name key.");
    }
  }
  function _validateOptionsArray(options2) {
    if (Array.isArray(options2) && typeof options2[0] === "object") {
      throw new Error(options2 + "is not a valid array of options.");
    }
  }

  // node_modules/@shopify/theme-product-form/theme-product-form.js
  var selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
  };
  function getUrlWithVariant(url, id2) {
    if (/variant=/.test(url)) {
      return url.replace(/(variant=)[^&]+/, "$1" + id2);
    } else if (/\?/.test(url)) {
      return url.concat("&variant=").concat(id2);
    }
    return url.concat("?variant=").concat(id2);
  }
  function ProductForm(element, product, options2) {
    this.element = element;
    this.product = _validateProductObject(product);
    options2 = options2 || {};
    this._listeners = new Listeners();
    this._listeners.add(this.element, "submit", this._onSubmit.bind(this, options2));
    this.optionInputs = this._initInputs(selectors.optionInput, options2.onOptionChange);
    this.quantityInputs = this._initInputs(selectors.quantityInput, options2.onQuantityChange);
    this.propertyInputs = this._initInputs(selectors.propertyInput, options2.onPropertyChange);
  }
  ProductForm.prototype.destroy = function() {
    this._listeners.removeAll();
  };
  ProductForm.prototype.options = function() {
    return _serializeOptionValues(this.optionInputs, function(item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2];
      return item;
    });
  };
  ProductForm.prototype.variant = function() {
    return getVariantFromSerializedArray(this.product, this.options());
  };
  ProductForm.prototype.properties = function() {
    var properties = _serializePropertyValues(this.propertyInputs, function(propertyName) {
      var regex = /(?:^(properties\[))(.*?)(?:\])/;
      var name = regex.exec(propertyName)[2];
      return name;
    });
    return Object.entries(properties).length === 0 ? null : properties;
  };
  ProductForm.prototype.quantity = function() {
    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
  };
  ProductForm.prototype._setIdInputValue = function(value) {
    var idInputElement = this.element.querySelector(selectors.idInput);
    if (!idInputElement) {
      idInputElement = document.createElement("input");
      idInputElement.type = "hidden";
      idInputElement.name = "id";
      this.element.appendChild(idInputElement);
    }
    idInputElement.value = value.toString();
  };
  ProductForm.prototype._onSubmit = function(options2, event) {
    event.dataset = this._getProductFormEventData();
    if (event.dataset.variant) {
      this._setIdInputValue(event.dataset.variant.id);
    }
    if (options2.onFormSubmit) {
      options2.onFormSubmit(event);
    }
  };
  ProductForm.prototype._onFormEvent = function(cb) {
    if (typeof cb === "undefined") {
      return Function.prototype;
    }
    return function(event) {
      event.dataset = this._getProductFormEventData();
      cb(event);
    }.bind(this);
  };
  ProductForm.prototype._initInputs = function(selector, cb) {
    var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
    return elements.map(function(element) {
      this._listeners.add(element, "change", this._onFormEvent(cb));
      return element;
    }.bind(this));
  };
  ProductForm.prototype._getProductFormEventData = function() {
    return {
      options: this.options(),
      variant: this.variant(),
      properties: this.properties(),
      quantity: this.quantity()
    };
  };
  function _serializeOptionValues(inputs, transform) {
    return inputs.reduce(function(options2, input) {
      if (input.checked || input.type !== "radio" && input.type !== "checkbox") {
        options2.push(transform({ name: input.name, value: input.value }));
      }
      return options2;
    }, []);
  }
  function _serializePropertyValues(inputs, transform) {
    return inputs.reduce(function(properties, input) {
      if (input.checked || input.type !== "radio" && input.type !== "checkbox") {
        properties[transform(input.name)] = input.value;
      }
      return properties;
    }, {});
  }
  function _validateProductObject(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }
    if (typeof product.variants[0].options === "undefined") {
      throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
    }
    return product;
  }

  // node_modules/@shopify/theme-currency/currency.js
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  // app/scripts/common/_product.js
  var productSettings = theme.product;
  var AT_Main = theme.ac;
  var Shopify2 = Shopify2 || {};
  Shopify2.optionsMap = {};
  Shopify2.updateOptionsInSelector = function(selectorIndex) {
    let parent = Shopify2.productContainer;
    switch (selectorIndex) {
      case 0:
        var key2 = "root", selector = parent.querySelector('[data-linked-option-select="0"]');
        break;
      case 1:
        var key2 = parent.querySelector('[data-linked-option-select="0"]').value, selector = parent.querySelector('[data-linked-option-select="1"]');
        break;
      case 2:
        var key2 = parent.querySelector('[data-linked-option-select="0"]').value, selector = parent.querySelector('[data-linked-option-select="2"]');
        key2 += " / " + parent.querySelector('[data-linked-option-select="1"]').value;
    }
    if (selector == null)
      return;
    var initialValue = selector.value, availableOptions = Shopify2.optionsMap[key2] || [], optionHTML = "";
    availableOptions.length && availableOptions.map((item) => {
      let option = document.createElement("option");
      option.value = item;
      option.innerHTML = item;
      optionHTML += option.outerHTML;
    });
    selector.innerHTML = optionHTML;
    let swatchItems = parent.querySelectorAll('[data-linked-option="' + selectorIndex + '"] [data-linked-option-item]');
    swatchItems.length && swatchItems.forEach(function(s) {
      let radio = s.querySelector('[type="radio"]');
      let value = radio.value;
      if (availableOptions.filter((i) => i == value).length) {
        s.setAttribute("data-linked-option-item", "");
        radio.removeAttribute("disabled");
      } else {
        s.setAttribute("data-linked-option-item", "disabled");
        radio.setAttribute("disabled", "disabled");
      }
    });
    if (availableOptions.filter((i) => i == initialValue).length) {
      selector.value = initialValue;
    }
    optionHTML != "" && selector.dispatchEvent(new Event("change"));
  };
  Shopify2.linkOptionSelectors = function(arg) {
    let product = arg.productJSON;
    let container = arg.container;
    Shopify2.productContainer = container;
    let variantAvailable = productSettings.only_available;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      let isAvailable = variantAvailable ? variant && variant.available : variant;
      if (isAvailable) {
        Shopify2.optionsMap["root"] = Shopify2.optionsMap["root"] || [];
        Shopify2.optionsMap["root"].push(variant.option1);
        Shopify2.optionsMap["root"] = [...new Set(Shopify2.optionsMap["root"])];
        if (product.options.length > 1) {
          var key2 = variant.option1;
          Shopify2.optionsMap[key2] = Shopify2.optionsMap[key2] || [];
          Shopify2.optionsMap[key2].push(variant.option2);
          Shopify2.optionsMap[key2] = [...new Set(Shopify2.optionsMap[key2])];
        }
        if (product.options.length === 3) {
          var key2 = variant.option1 + " / " + variant.option2;
          Shopify2.optionsMap[key2] = Shopify2.optionsMap[key2] || [];
          Shopify2.optionsMap[key2].push(variant.option3);
          Shopify2.optionsMap[key2] = [...new Set(Shopify2.optionsMap[key2])];
        }
      }
    }
    Shopify2.updateOptionsInSelector(0);
    if (product.options.length > 1)
      Shopify2.updateOptionsInSelector(1);
    if (product.options.length === 3)
      Shopify2.updateOptionsInSelector(2);
    let select0 = container.querySelector('[data-linked-option-select="0"]');
    select0 != null && select0.addEventListener("change", function() {
      Shopify2.updateOptionsInSelector(1);
      if (product.options.length === 3)
        Shopify2.updateOptionsInSelector(2);
      return true;
    });
    let select1 = container.querySelector('[data-linked-option-select="1"]');
    select1 != null && select1.addEventListener("change", function() {
      if (product.options.length === 3)
        Shopify2.updateOptionsInSelector(2);
      return true;
    });
  };
  var AT_Product = {
    init: function(container) {
      this.container = container;
      this.initEvents();
      this.themeProduct_slide();
      this.themeProduct();
    },
    settings: {
      price_sale: "[data-price-sale]",
      price_compare: "[data-price-compare]",
      price: "[data-price-single]",
      soldout: "[data-soldout]"
    },
    initEvents: function() {
      let this2 = this;
      if (productSettings.disabled_first) {
        AT_Main.addEvent(document, "click", ".swatch-item", (e) => {
          if (!productSettings.disabled_first || Shopify2.linkOptionSelectors == null)
            return;
          productSettings.disabled_first = false;
          Shopify2.linkOptionSelectors(this2.productJSON);
        });
        document.querySelectorAll(".select-option select").length && document.querySelectorAll(".select-option select").forEach((op) => {
          op.addEventListener("change", function(e) {
            if (!productSettings.disabled_first || Shopify2.linkOptionSelectors == null)
              return;
            productSettings.disabled_first = false;
            Shopify2.linkOptionSelectors(this2.productJSON);
          });
        });
      }
      AT_Main.addEvent(document, "click", ".product__toggle-link", (e) => {
        e.preventDefault();
        let this4 = e.target;
        let id2 = this4.dataset.id;
        let currentShow = this2.container.querySelectorAll(".product__toggle-item.active");
        let nav = this2.container.querySelectorAll(".product__toggle-nav.active");
        console.log(this2.container);
        if (AT_Main.getWidthBrowser() > 768) {
          currentShow.length && currentShow.forEach((t) => t.classList.remove("active"));
          nav.length && nav.forEach((t) => t.classList.remove("active"));
        }
        let tab = document.getElementById(id2);
        tab != null && tab.classList.toggle("active");
        let navLink = this2.container.querySelectorAll(`[data-id="${id2}"]`);
        navLink.length && navLink.forEach((nav2) => nav2.closest(".product__toggle-nav").classList.toggle("active"));
      });
    },
    themeProduct: function() {
      let this2 = this;
      let formElement = this.container.querySelector("[data-product-form]"), productHandle = formElement.dataset.productHandle;
      this.form = formElement;
      let url = [theme.routes.cart_url.replace("cart", "products"), "/", productHandle].join("");
      fetch(`${url}.js`).then((response) => {
        response.json().then((productJSON) => {
          this2.productJSON = productJSON;
          let data = new ProductForm(formElement, productJSON, { onOptionChange: this2.themeProduct_variants });
          this2.initSwatch();
          !productSettings.disabled_first && Shopify2.linkOptionSelectors != null && new Shopify2.linkOptionSelectors(this2);
        }).catch((error) => {
          console.log(error);
        });
      });
    },
    themeProduct_variants: function(e) {
      let this2 = AT_Product;
      let variant = e.dataset.variant;
      let settings = this2.settings;
      let container = this2.container;
      let addCartBtn = container.querySelector('button[type="submit"]');
      let stock = container.querySelector("#stock");
      if (variant) {
        if (container.tagName != "DIALOG") {
          const url = getUrlWithVariant(window.location.href, variant.id);
          window.history.replaceState({ path: url }, "", url);
        }
        container.querySelector('[name="id"]').value = variant.id;
        addCartBtn.classList.contains("btn-require-options") && addCartBtn.classList.remove("btn-require-options");
        if (variant.featured_media) {
          let imageEl = container.querySelector(`.media-thumbnail[data-media-id="${variant.featured_media.id}"]`);
          imageEl != null && imageEl.dispatchEvent(new Event("click"));
        }
        if (variant.available) {
          addCartBtn.removeAttribute("disabled");
          stock != null && (stock.innerHTML = theme.product.in_stock);
        } else {
          addCartBtn.setAttribute("disabled", "disabled");
          stock != null && (stock.innerHTML = theme.product.out_stock);
        }
        let priceRange = container.querySelector(".product-price-range");
        priceRange != null && priceRange.classList.add("hide");
        container.querySelector("[data-product-price]").classList.remove("hide");
        if (document.querySelectorAll(".swatch-item").length) {
          variant.options.map((s) => {
            let el = document.createElement("div");
            el.innerText = s;
            let value = el.innerHTML.replace(/["\\]/g, "\\$&");
            let selectSwatch = document.querySelector(`[data-linked-option-item] [value="${value}"]`);
            selectSwatch != null && (selectSwatch.closest("[data-linked-option]").querySelectorAll("input:checked").forEach((i) => i.checked = false), selectSwatch.checked = true);
          });
        }
      } else {
        addCartBtn.setAttribute("disabled", "disabled");
      }
      this2.changePrice(variant, container, settings);
    },
    themeProduct_slide: function() {
      let mainMedia = this.container.querySelector(".product-gallery--main");
      let thumbMedia = this.container.querySelector(".product-gallery--thumbnail");
      let featuredIndex = this.container.querySelector("[data-media-id].active");
      let startIndex = featuredIndex != null ? +featuredIndex.dataset.index : 0;
      if (theme.slider == null || mainMedia.children.length < 2)
        return;
      this.mainGallery = theme.slider({
        container: mainMedia,
        items: 1,
        startIndex,
        gutter: 30,
        loop: false,
        controls: false,
        navContainer: thumbMedia,
        navAsThumbnails: true,
        mouseDrag: true,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false
      });
      this.mainGallery.events.on("transitionStart", function(e) {
        let container = e.container;
        [...container.querySelectorAll("video")].map((i) => i.pause());
        let slideItem = container.querySelector(`.tns-item[data-index="${e.index}"]`);
        if (slideItem) {
          let video = slideItem.querySelector("video");
          video != null && video.play();
        }
      });
      if (thumbMedia != null) {
        let config = {
          container: thumbMedia,
          items: 4.2,
          startIndex,
          gutter: 8,
          loop: false,
          nav: false,
          controls: true,
          controlsContainer: this.container.querySelector(".product-thumbnail--navigation"),
          mouseDrag: true,
          preventActionWhenRunning: false,
          preventScrollOnTouch: false
        };
        this.thumbnailGallery = theme.slider(config);
      }
    },
    initSwatch: function() {
      let this2 = this;
      let swtArray = this2.container.querySelectorAll('[data-swatch-wrapper] input[type="radio"]');
      if (!swtArray.length) {
        return;
      }
      swtArray.forEach((swt) => {
        swt.addEventListener("change", (e) => {
          let value = swt.value, optionSelect = this2.container.querySelector(swt.closest(".swatch-option").getAttribute("data-target"));
          optionSelect.value = value;
          optionSelect.dispatchEvent(new Event("change"));
        });
      });
    },
    changePrice: (variant, target, settings) => {
      let price = target.querySelector(settings.price) || {}, priceSale = target.querySelector(settings.price_sale) || {}, priceCompare = target.querySelector(settings.price_compare) || {}, soldout = target.querySelector(settings.soldout) || {};
      price.classList.add("hide");
      priceSale.classList.add("hide");
      priceCompare.classList.add("hide");
      soldout.classList.add("hide");
      if (variant === null || !variant.available) {
        soldout.classList.remove("hide");
        return;
      }
      if (variant.available) {
        soldout.classList.add("hide");
        if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
          priceSale.innerHTML = formatMoney(variant.price, theme.currency.moneyFormat);
          priceCompare.innerHTML = formatMoney(variant.compare_at_price, theme.currency.moneyFormat);
          priceSale.classList.remove("hide");
          priceCompare.classList.remove("hide");
        } else {
          price.innerHTML = formatMoney(variant.price, theme.currency.moneyFormat);
          price.classList.remove("hide");
        }
      }
      theme.currency && theme.currency.convert && theme.currency.convert(".product-info .money");
    }
  };
  var product_default = AT_Product;

  // node_modules/tiny-slider/src/helpers/raf.js
  var win = window;
  var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function(cb) {
    return setTimeout(cb, 16);
  };

  // node_modules/tiny-slider/src/helpers/caf.js
  var win2 = window;
  var caf = win2.cancelAnimationFrame || win2.mozCancelAnimationFrame || function(id2) {
    clearTimeout(id2);
  };

  // node_modules/tiny-slider/src/helpers/docElement.js
  var docElement = document.documentElement;

  // node_modules/tiny-slider/src/helpers/classListSupport.js
  var classListSupport = "classList" in document.createElement("_");

  // node_modules/tiny-slider/src/helpers/passiveOption.js
  var supportsPassive = false;
  try {
    opts = Object.defineProperty({}, "passive", {
      get: function() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {
  }
  var opts;

  // node_modules/tiny-slider/src/tiny-slider.js
  if (!Object.keys) {
    Object.keys = function(object) {
      var keys = [];
      for (var name in object) {
        if (Object.prototype.hasOwnProperty.call(object, name)) {
          keys.push(name);
        }
      }
      return keys;
    };
  }
  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  // app/scripts/common/_arn.js
  var import_easytimer = __toModule(require_easytimer());

  // node_modules/@shopify/theme-images/images.js
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return removeProtocol(src);
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  // node_modules/@shopify/theme-cart/request.js
  function getDefaultRequestConfig() {
    return JSON.parse(JSON.stringify({
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;"
      }
    }));
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function(response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = "POST";
    config.body = JSON.stringify(body);
    return fetchJSON("/cart/update.js", config);
  }

  // node_modules/@shopify/theme-cart/theme-cart.js
  function updateAttributes(attributes) {
    return cartUpdate({ attributes });
  }

  // app/scripts/common/_currency.js
  var AT_Currency = {
    currenciesCallback: function() {
      if (theme.currency.type != "2") {
        return;
      }
      var shopCurrency = "", defaultCurrency = "", cookieCurrency = "";
      let self2 = this;
      theme.currency.currenciesCallback = () => {
        if (Currency == null || theme.currency == null) {
          return;
        }
        Currency.format = theme.currency.currency_format;
        shopCurrency = theme.currency.shopCurrency;
        let formCurrency = document.querySelector('select[name="currency"]');
        if (formCurrency.value != shopCurrency) {
          formCurrency.value = shopCurrency;
          formCurrency.dispatchEvent(new Event("change"));
          formCurrency.closest("form").submit();
        }
        Currency.money_with_currency_format[shopCurrency] = theme.currency.moneyFormatWithCurrency_strip;
        Currency.money_format[shopCurrency] = theme.currency.moneyFormat_strip;
        defaultCurrency = shopCurrency;
        cookieCurrency = Currency.cookie.read();
        let spanMoney = document.querySelectorAll("span.money");
        spanMoney.length && spanMoney.forEach((s) => {
          s.setAttribute(`data-currency-${shopCurrency}`, s.innerHTML);
        });
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
          } else {
            Currency.currentCurrency = defaultCurrency;
          }
          Currency.cookie.write(defaultCurrency);
        } else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        } else {
          typeof cookieCurrency == "undefined" && (cookieCurrency = defaultCurrency);
          Currency.convertAll(shopCurrency, cookieCurrency);
          Currency.convertAll(Currency.currentCurrency, cookieCurrency);
        }
        self2.updateState();
      };
      theme.currency.currenciesCallbackSpecial = (id2) => {
        if (typeof Currency == "undefined" || typeof theme.currency == "undefined") {
          return;
        }
        let target = document.querySelectorAll(id2);
        target.length && target.forEach((element) => {
          element.setAttribute(`data-currency-${shopCurrency}`, element.innerHTML);
        });
        Currency.convertAll(shopCurrency, Currency.cookie.read(), id2, theme.currency.currency_format);
      };
    },
    convert: function(id2) {
      if (theme.currency.type != "2" || !theme.currency || !theme.currency.currenciesCallbackSpecial) {
        return;
      }
      theme.currency.currenciesCallbackSpecial(id2);
    },
    updateState: function() {
      if (theme.currency.type != "2") {
        return;
      }
      let currentCurrency = _AC.getCookie("currency");
      let labelCurrency = document.querySelectorAll("[data-currency-code]");
      let btnCurrency = document.querySelectorAll(".btn-currency[data-value]");
      currentCurrency.includes(";") && (currentCurrency = currentCurrency.split(";")[0]);
      labelCurrency.length && labelCurrency.forEach((c) => {
        c.textContent = currentCurrency;
      });
      btnCurrency.length && btnCurrency.forEach((b) => {
        b.getAttribute("data-value") == currentCurrency ? b.classList.add("active") : b.classList.remove("active");
      });
    },
    initEvents: function() {
      let self2 = this;
      _AC.addEvent(document, "click", ".btn-currency", (e) => {
        e.preventDefault();
        let _this = e.target, value = _this.getAttribute("data-value");
        switch (theme.currency.type) {
          case "1":
            let formCurrency = document.querySelector("form.shopify-currency-form");
            if (formCurrency == null) {
              return;
            }
            let optionSelect = formCurrency.querySelector("select");
            optionSelect.value = value;
            optionSelect.dispatchEvent(new Event("change"));
            formCurrency.submit();
            break;
          case "2":
            typeof Currency != "undefined" && Currency.convertAll(Currency.currentCurrency, value);
            self2.updateState();
            break;
          default:
        }
      });
      theme.currency.type == "2" && theme.currency.currenciesCallback();
    },
    init: function() {
      if (!theme.currency.enable) {
        return;
      }
      let self2 = this;
      self2.currenciesCallback();
      self2.initEvents();
    }
  };
  var currency_default = AT_Currency;

  // app/scripts/common/_tool.js
  var import_zenscroll = __toModule(require_zenscroll());
  var _AC2 = {
    addEvent: function(parent, evt, selector, handler) {
      parent.addEventListener(evt, function(event) {
        if (event.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event.target.closest(selector), arguments);
        }
      }, false);
    },
    debounceTime: function(time, func) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var excuteFn = function() {
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(excuteFn, time);
      };
    },
    detectDeviceType: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
    },
    escape: function(text) {
      return text.replace(/[<>\&\"\']/g, function(c) {
        return "&#" + c.charCodeAt(0) + ";";
      });
    },
    fadeOut: function(elem, ms = 400) {
      if (!elem)
        return;
      if (ms) {
        var opacity = 1;
        var timer = setInterval(function() {
          opacity -= 50 / ms;
          if (opacity <= 0) {
            clearInterval(timer);
            opacity = 0;
            elem.style.display = "none";
            elem.style.visibility = "hidden";
          }
          elem.style.opacity = opacity;
          elem.style.filter = "alpha(opacity=" + opacity * 100 + ")";
        }, 50);
      } else {
        elem.style.opacity = 0;
        elem.style.filter = "alpha(opacity=0)";
        elem.style.display = "none";
        elem.style.visibility = "hidden";
      }
    },
    getCookie: function(name) {
      let dc = document.cookie, prefix = name + "=", begin = dc.indexOf("; " + prefix), end;
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0)
          return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
    },
    getWidthBrowser: function() {
      let myWidth;
      if (typeof window.innerWidth == "number") {
        myWidth = window.innerWidth;
      } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        myWidth = document.documentElement.clientWidth;
      } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        myWidth = document.body.clientWidth;
      }
      return myWidth;
    },
    getHeightBrowser: function() {
      let result;
      if (typeof window.innerHeight == "number") {
        result = window.innerHeight;
      } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        result = document.documentElement.clientHeight;
      } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        result = document.body.clientHeight;
      }
      return result;
    },
    handle: function(text) {
      return text.toLowerCase().replace(/[^\w\s.\//]/gi, "").trim().replace(/[\s.\//]/g, "-");
    },
    isExist: function(element) {
      return element == null || typeof element == "undefined" ? false : true;
    },
    scrollBarWidth: function() {
      let { left, right } = document.body.getBoundingClientRect();
      if (left + right < window.innerWidth)
        return window.innerWidth - (left + right);
      return 0;
    },
    scrollTo: function(selector) {
      let self2 = this;
      let el = typeof selector == "string" ? document.querySelector(selector) : selector;
      if (el == null) {
        return;
      }
      let elTop = el.getBoundingClientRect().top;
      let winTop = window.pageYOffset != void 0 ? window.pageYOffset : window.scrollTop;
      import_zenscroll.default.center(el, 1e3);
    },
    removeSquareBracket: function(text) {
      return text.replace(/\[|\]/g, "");
    },
    activeLazyload: function(selector, fn) {
      return new Promise((resolve, reject) => {
        selector.addEventListener("lazyincludeloaded", (e) => {
          fn(e);
          resolve(true);
        });
      });
    }
  };
  var tool_default = _AC2;

  // app/scripts/common/_arn.js
  var oldWidth = 0;
  var dialog = {
    notify: "#dialogNotify"
  };
  var AT_Main2 = {
    onClick: function(className, callBack, container = document) {
      let target = container.querySelectorAll(className);
      target.length && target.forEach(function(el, index) {
        el.addEventListener("click", callBack);
      });
    },
    isExist: (element) => {
      return element == null || typeof element == "undefined" ? false : true;
    },
    initDialog: () => {
      tool_default.addEvent(document, "click", "[data-dialog-trigger]", async (e) => {
        e.preventDefault();
        let _this = e.target, value = _this.getAttribute("data-dialog-trigger"), downVal = value.toLowerCase(), _target = document.querySelector(value);
        if (!tool_default.isExist(_target)) {
          return;
        }
        document.body.classList.add("lazy-loading");
        if (tool_default.isExist(_target.querySelector(":scope > .lazyload[data-include]"))) {
          _target.classList.add("lazy-active");
          await tool_default.activeLazyload(_target, (e2) => {
            _target.classList.remove("lazy-active");
          });
        }
        AT_Main2.disablePageScroll(true);
        document.body.classList.remove("lazy-loading");
        _target.classList.toggle("is-open");
        downVal.includes("menumobile") && document.body.classList.toggle("menuMobile-is-active");
        if (!_target.classList.contains("is-open")) {
          return;
        }
        ;
        currency_default.convert(value + " .money");
        (downVal.includes("currency") || downVal.includes("menumobile")) && currency_default.updateState();
        value.toLowerCase().includes("search") && _target.querySelector('input[name="q"]').focus();
      });
      tool_default.addEvent(document, "click", "[data-dialog-close]", (e) => {
        let _this = e.target, _target = _this.closest("dialog");
        if (!tool_default.isExist(_target)) {
          return;
        }
        e.preventDefault();
        _target.classList.remove("is-open");
        _target.getAttribute("id") == "menuMobile" && document.body.classList.remove("menuMobile-is-active");
        AT_Main2.disablePageScroll(false);
      });
    },
    triggerDialog(target, method = "show") {
      let _target = document.getElementById(target.replace(/^\W/g, ""));
      if (_target == null) {
        return;
      }
      if (method == "show") {
        document.querySelectorAll("dialog.is-open").length && document.querySelectorAll("dialog.is-open").forEach((element) => {
          element.classList.remove("is-open");
        });
        document.body.classList.contains("menuMobile-is-active") && document.body.classList.remove("menuMobile-is-active");
        _target.classList.add("is-open");
        AT_Main2.disablePageScroll(true);
        return;
      }
      _target.classList.remove("is-open");
      AT_Main2.disablePageScroll(false);
    },
    tabPanel_init: (container = null) => {
      let $container = container || document;
      let tabLink = $container.querySelectorAll(".featured_group_tab-ui .featured_group_tab-link a");
      tabLink.length && tabLink.forEach((e) => {
        e.addEventListener("click", (e2) => {
          e2.preventDefault();
          let _this = e2.currentTarget, _target = $container.querySelector(_this.getAttribute("href"));
          if (_this.closest(".featured_group_tab-link").classList.contains("active") || !tool_default.isExist(_target)) {
            return;
          }
          let paneParent = _target.closest(".featured_group_tab-ui");
          paneParent.querySelectorAll(".featured_group_tab-pane.active, .featured_group_tab-link.active").forEach((e3, i) => {
            e3.classList.remove("active");
          });
          _this.closest(".featured_group_tab-link").classList.add("active");
          _target.classList.add("active");
        });
      });
    },
    initSlider: function(container) {
      let this2 = this;
      let ss = container, conf = ss.querySelector(`input[name="sectionSlideConfig"]`), target = ss.querySelectorAll(".slide_ui-element");
      if (!tool_default.isExist(target) || !tool_default.isExist(conf) || theme.slider == null) {
        return;
      }
      let autoplay = false, autoplayTimeout = 5e3, center = false, animateIn = "tns-fadeIn", animateOut = "tns-fadeOut", speed = 300, edgePadding = 0, controls = conf.getAttribute("data-nav") ? JSON.parse(conf.getAttribute("data-nav")) : false, nav = conf.getAttribute("data-dot") ? JSON.parse(conf.getAttribute("data-dot")) : false, loop = conf.getAttribute("data-loop") ? JSON.parse(conf.getAttribute("data-loop")) : false, autoWidth = conf.getAttribute("data-auto-width") ? JSON.parse(conf.getAttribute("data-auto-width")) : false, items = conf.getAttribute("data-items").split(","), gutters = conf.getAttribute("data-gutters") || "", itemClass = conf.getAttribute("data-item-class");
      gutters = gutters.replace(/[^\d.,]/g, "").split(",");
      let sectionType = ss.getAttribute("data-section-type") || "";
      target.forEach((v, i) => {
        let wrapper = v.closest("div[data-slide-wrapper]") || ss;
        v.classList.remove("row", "d-grid");
        let responsive = {
          0: { items: +items[5] || +items[0], gutter: +gutters[5] || +gutters[0], center },
          375: { items: +items[4] || +items[0], gutter: +gutters[4] || +gutters[0], center },
          576: { items: +items[3] || +items[0], gutter: +gutters[3] || +gutters[0], center },
          768: { items: +items[2] || +items[0], gutter: +gutters[2] || +gutters[0], center: false },
          992: { items: +items[1] || +items[0], gutter: +gutters[1] || +gutters[0], center: false },
          1200: { items: +items[0] || +items[0], gutter: +gutters[0] || +gutters[0], center: false }
        };
        if (itemClass != "") {
          for (var i = 0; i < v.children.length; i++) {
            v.children[i].className = itemClass;
          }
        }
        let config = {
          container: v,
          items: items[5],
          gutter: gutters[5],
          slideBy: "page",
          startIndex: 0,
          loop,
          speed,
          edgePadding,
          mouseDrag: true,
          swipeAngle: 30,
          autoplayButtonOutput: false,
          autoplay,
          autoplayTimeout,
          animateIn,
          animateOut,
          controls,
          controlsPosition: "bottom",
          controlsContainer: wrapper.querySelector(".slide_ui-controls--nav"),
          nav,
          navPosition: "bottom",
          responsive,
          preventActionWhenRunning: false,
          preventScrollOnTouch: false,
          onInit: () => {
            if (tool_default.isExist(ss.querySelector(".tns-nav"))) {
              ss.querySelector(".tns-nav").classList.add("slide_ui-controls", "slide_ui-controls--dot");
            }
            if (sectionType.includes("product")) {
              v.querySelector(".tns-slide-active").classList.add("tns-first");
              v.querySelectorAll(".tns-slide-active")[v.querySelectorAll(".tns-slide-active").length - 1].classList.add("tns-last");
            }
            ss.closest(".layout-full-right") != null && this2.handleTestimonial(ss, "resize");
          }
        };
        let sliderTNS = theme.slider(config);
        if (sectionType.includes("product")) {
          sliderTNS.events.on("indexChanged", (info, eventName) => {
            v.querySelectorAll(".tns-first, .tns-last").forEach((item) => {
              item.classList.remove("tns-first", "tns-last");
            });
            v.querySelector(".tns-slide-active").classList.add("tns-first");
            v.querySelectorAll(".tns-slide-active")[v.querySelectorAll(".tns-slide-active").length - 1].classList.add("tns-last");
          });
        }
      });
    },
    handleTestimonial: function(container, event = null) {
      let this2 = this;
      let calcEl = container.querySelector(".calc-container");
      let slideEl = container.querySelector(".tns-slider");
      let slideOuter = container.querySelector(".tns-outer");
      let translatedLeft = (container.clientWidth - calcEl.clientWidth) / 2;
      slideOuter.style.cssText = `padding-left: ${translatedLeft}px !important`;
      if (event == null) {
        return;
      }
      window.addEventListener("resize", function(e) {
        this2.handleTestimonial(container);
      });
    },
    escape: (text) => {
      return text.replace(/[<>\&\"\']/g, function(c) {
        return "&#" + c.charCodeAt(0) + ";";
      });
    },
    handle: (text) => {
      return text.toLowerCase().replace(/[^\w\s.\//]/gi, "").trim().replace(/[\s.\//]/g, "-");
    },
    removeSquareBracket: (text) => {
      return text.replace(/\[|\]/g, "");
    },
    setCookie: (cname, cvalue, exdays) => {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1e3);
      let expires = "expires=" + d.toUTCString();
      document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
    },
    getCookie: (name) => {
      let dc = document.cookie, prefix = name + "=", begin = dc.indexOf("; " + prefix), end;
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0)
          return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
          end = dc.length;
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end));
    },
    clickModal: function(target) {
      tool_default.addEvent(document, "click", target, async (e) => {
        e.preventDefault();
        let _id = e.target.getAttribute("data-target") || "";
        let target2 = document.querySelector(_id);
        if (_id == "" || !tool_default.isExist(target2)) {
          return;
        }
        if (target2.classList.contains("active")) {
          target2.classList.remove("active");
          AT_Main2.disablePageScroll(false);
        } else {
          target2.classList.add("active");
          AT_Main2.disablePageScroll(true);
        }
      });
    },
    disablePageScroll: function(_bool, _class = null) {
      let bodyClass = [];
      bodyClass.push("modal-opened");
      _class != null && bodyClass.push(_class);
      let pr = tool_default.scrollBarWidth();
      if (_bool) {
        document.body.style.setProperty("padding-right", pr + "px");
        document.body.classList.add(...bodyClass);
        return;
      }
      document.body.style.removeProperty("padding-right");
      document.body.classList.remove(...bodyClass);
      return;
    },
    ajaxCall: (url, callback, method, postData, dataType) => {
      if (!window.XMLHttpRequest) {
        return null;
      }
      var req = new XMLHttpRequest();
      method = method || "GET";
      postData = postData || null;
      dataType = dataType || "text/plain";
      req.open(method, url);
      req.setRequestHeader("Content-Type", dataType);
      req.onreadystatechange = function() {
        if (req.readyState === 4) {
          if (req.status === 200) {
            callback(req.responseText);
          } else {
            console.log(req);
          }
        }
      };
      req.send(postData);
      return req;
    },
    recordRecentView: function(handle) {
      let recentView = AT_Main2.getCookie("recentViewItem");
      recentView != null && (handle += `|${recentView}`);
      recentView = [...new Set(handle.split("|"))].join("|");
      AT_Main2.setCookie("recentViewItem", recentView);
    },
    recentView: async function() {
      let self2 = this;
      let max = +theme.product.recent_total, recentView = AT_Main2.getCookie("recentViewItem"), recentContainer = document.querySelector("#recentlyView"), lastestView = theme.productSettings ? theme.productSettings.handle : "";
      if (recentView == null || !tool_default.isExist(recentContainer)) {
        return;
      }
      let productHandle = [...new Set(recentView.split("|"))];
      productHandle.length > max && (productHandle = productHandle.slice(0, max + 1));
      AT_Main2.setCookie("recentViewItem", productHandle.join("|"));
      let lastestViewArray = productHandle.map(async (i) => {
        let url = `${theme.routes.search_url.replace("search", "")}products/${i}.js`;
        let resp = await fetch(url);
        let item = resp.ok ? resp.json() : "";
        return item;
      });
      let rencentRS = await Promise.all(lastestViewArray);
      (rencentRS.length > 1 || rencentRS.length == 1 && rencentRS.some((i) => i.handle != lastestView)) && (recentContainer.style.display = "block");
      if (recentContainer.style.display != "block") {
        return;
      }
      let itemArray = [];
      rencentRS.forEach(async (value, index) => {
        if (value.handle && value.handle != lastestView) {
          await itemArray.push(self2.renderItem(value, "[data-recent-container]"));
        }
      });
      let itemArrayResult = await Promise.all(itemArray);
      AT_Main2.initSlider(recentContainer);
      currency_default.convert("#recentlyView .money");
    },
    renderItem: async (item, target) => {
      let settings = {
        productCard: "#productCardLayout",
        itemKey: "[data-item-key]",
        itemImage: "[data-item-image]",
        itemURL: "[data-item-url]",
        itemTitle: "[data-item-title]",
        itemOption: "[data-item-option]",
        itemPrice: "[data-item-price]",
        itemComparePrice: "[data-item-price-compare]"
      }, wrapper = document.querySelector(target), selector = document.querySelector(settings.productCard) || AT_Main2.renderSelector;
      if (wrapper == null) {
        return;
      }
      if (selector == null) {
        let itemHTML = new Promise((re, rs) => {
          fetch(theme.routes.search_url + "?view=include.product-item").then((e) => {
            e.text().then((resp) => {
              re(resp);
            });
          });
        });
        let result = await itemHTML;
        let parser = new DOMParser();
        let html = parser.parseFromString(result, "text/html");
        selector = html.querySelector(settings.productCard);
      }
      let productSelected = item.variants[0];
      selector.querySelectorAll(settings.itemURL).forEach((e) => {
        e.setAttribute("href", item.url);
      });
      selector.querySelector(settings.itemTitle).innerHTML = item.title;
      selector.querySelector(settings.itemPrice).innerHTML = formatMoney(item.price, theme.currency.moneyFormat);
      selector.querySelector(settings.itemComparePrice).innerHTML = formatMoney(item.compare_at_price, theme.currency.moneyFormat);
      let image = item.featured_image || theme.product.default_image;
      selector.querySelector(settings.itemImage).setAttribute("data-src", getSizedImageUrl(image, "280x"));
      selector.querySelector(settings.itemImage).setAttribute("alt", item.title);
      selector.querySelector(settings.itemImage).classList.add("lazyload");
      if (item.compare_at_price == null)
        selector.querySelector(settings.itemComparePrice).classList.add("hide");
      else
        selector.querySelector(settings.itemComparePrice).classList.remove("hide");
      let _html = selector.innerHTML;
      target == "[data-recent-container]" && (_html = `<div class="product-section">${_html}</div>`);
      wrapper.insertAdjacentHTML("beforeend", _html);
      return true;
    },
    getItems: async (arrayHandle, index = 0) => {
      if (index >= arrayHandle.length) {
        return;
      }
      let url = `${theme.routes.search_url.replace("search", "")}products/${arrayHandle[index]}.js`;
      let response = await fetch(url);
      return await response.json();
    },
    moneyFormat: (price) => {
      return formatMoney(price, theme.currency.moneyFormat);
    },
    changePrice: (variant, target, settings) => {
      let price = target.querySelector(settings.price) || {}, priceSale = target.querySelector(settings.price_sale) || {}, priceCompare = target.querySelector(settings.price_compare) || {}, soldout = target.querySelector(settings.soldout) || {};
      price.classList.add("hide");
      priceSale.classList.add("hide");
      priceCompare.classList.add("hide");
      soldout.classList.add("hide");
      if (variant === null || !variant.available) {
        soldout.classList.remove("hide");
        return;
      }
      if (variant.available) {
        soldout.classList.add("hide");
        if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
          priceSale.innerHTML = formatMoney(variant.price, theme.currency.moneyFormat);
          priceCompare.innerHTML = formatMoney(variant.compare_at_price, theme.currency.moneyFormat);
          priceSale.classList.remove("hide");
          priceCompare.classList.remove("hide");
        } else {
          price.innerHTML = formatMoney(variant.price, theme.currency.moneyFormat);
          price.classList.remove("hide");
        }
      }
    },
    easyTimer_HTML: function(selector, value) {
      if (value > 9) {
        let arrValue = value.toString().split("");
        arrValue.forEach((val, index) => {
          let target = selector.querySelector(`.date-value[data-index="${index + 1}"]`);
          if (!tool_default.isExist(target)) {
            let prevElment = selector.querySelector(`.date-value[data-index="${index}"]`);
            let renderHTML = prevElment.outerHTML.replace(`data-index="${index}"`, `data-index="${index + 1}"`).replace(`${prevElment.innerHTML}</span>`, `${arrValue[index]}</span`);
            selector.querySelector(`.date-value[data-index="${index}"]`).insertAdjacentHTML("afterend", renderHTML);
            return;
          }
          target.innerHTML = arrValue[index];
        });
      } else {
        selector.querySelector('.date-value[data-index="1"]').innerHTML = 0;
        selector.querySelector('.date-value[data-index="2"]').innerHTML = value;
      }
    },
    init_EasyTimer: function(selector, time_second) {
      let timer = new import_easytimer.Timer();
      timer.start({ countdown: true, startValues: { seconds: time_second } });
      timer.addEventListener("secondsUpdated", function(e) {
        let d = timer.getTimeValues().days, h = timer.getTimeValues().hours, m = timer.getTimeValues().minutes, s = timer.getTimeValues().seconds;
        let totalHours = d * 24 + h;
        totalHours > 99 ? AT_Main2.easyTimer_HTML(selector.querySelector(".count-day"), d) : selector.querySelector(".count-day").classList.add("hide");
        AT_Main2.easyTimer_HTML(selector.querySelector(".count-hrs"), totalHours > 99 ? h : totalHours);
        AT_Main2.easyTimer_HTML(selector.querySelector(".count-min"), m);
        AT_Main2.easyTimer_HTML(selector.querySelector(".count-sec"), s);
        if (!JSON.parse(selector.getAttribute("data-hide-label"))) {
          let d_t = d > 1 ? theme.dateLabel.days : theme.dateLabel.day, h_t = h > 1 ? theme.dateLabel.hours : theme.dateLabel.hour, m_t = m > 1 ? theme.dateLabel.minutes : theme.dateLabel.minute, s_t = s > 1 ? theme.dateLabel.seconds : theme.dateLabel.second;
          selector.querySelector(".count-day .date-label").innerHTML = d_t;
          selector.querySelector(".count-hrs .date-label").innerHTML = h_t;
          selector.querySelector(".count-min .date-label").innerHTML = m_t;
          selector.querySelector(".count-sec .date-label").innerHTML = s_t;
        }
        selector.classList.add("countdown-loaded");
      });
      timer.addEventListener("targetAchieved", function(e) {
        selector.classList.add("hide");
      });
    },
    initCountdown: function(target = null) {
      let container = target;
      if (container == null) {
        container = document;
      }
      let countdownItems = container.querySelectorAll(".countdown-time:not(.countdown-loaded)");
      if (!countdownItems.length) {
        return;
      }
      countdownItems.forEach((e) => {
        if (!e.classList.contains("countdown-loaded")) {
          let _this = e, _value = _this.getAttribute("data-date").split("/"), _date = new Date(_value[2], Number(_value[0]) - 1, _value[1]).getTime() / 1e3, _now = new Date().getTime() / 1e3, countdownTime = _date > _now ? _date - _now : 0;
          if (countdownTime > 0)
            AT_Main2.init_EasyTimer(_this, countdownTime);
          else
            _this.remove();
        }
      });
    },
    initCountryProvinceSelector: () => {
      let target = document.querySelectorAll(".customer_address_table[data-id]");
      if (!target.length) {
        return;
      }
      new Shopify.CountryProvinceSelector("address_country_new", "address_province_new", { hideElement: "address_province_container_new" });
      target.forEach((element) => {
        let formId = element.getAttribute("data-id");
        let countrySelector = "address_country_" + formId;
        let provinceSelector = "address_province_" + formId;
        let containerSelector = "address_province_container_" + formId;
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
      });
    },
    initVideo: function(container) {
      let buttonVideo = container.querySelectorAll("[data-button-video]");
      buttonVideo.length && buttonVideo.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          let parent = e.currentTarget.closest("[data-video-container]"), videoElement = parent.querySelector("video");
          if (parent.classList.contains("video-playing")) {
            parent.classList.remove("video-playing");
            tool_default.isExist(videoElement) && videoElement.pause();
          } else {
            parent.classList.add("video-playing");
            tool_default.isExist(videoElement) && videoElement.play();
          }
        });
      });
    },
    scrollToTop: function() {
      let bodyTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (bodyTop > 0) {
        window.requestAnimationFrame(AT_Main2.scrollToTop);
        window.scrollTo(0, bodyTop - bodyTop / 8);
      }
    },
    resetCollectionPagination: () => {
      if (theme.collectionPagination == null) {
        return;
      }
      updateAttributes({ pagination: null });
    },
    fixReview: function() {
      let reviewLazy = document.querySelectorAll(".featured_product__item-review:not(.loaded)");
      reviewLazy.length && reviewLazy.forEach((e) => {
        e.addEventListener("lazyincludeloaded", (evt) => {
          if (theme.product.review_type == "shopify" && typeof SPR != "undefined") {
            SPR.initDomEls();
            window.loadBadges.call(SPR);
          }
        });
      });
    },
    showNotify: async function(text) {
      let content = document.querySelector(dialog.notify);
      if (content == null) {
        let getDialog = await fetch(`${theme.routes.search_url}?view=dialog.notification`);
        let dialogEl = await getDialog.text();
        document.body.insertAdjacentHTML("beforeend", dialogEl);
        content = document.querySelector(dialog.notify);
      }
      content = content.querySelector("[data-notify-content]");
      content.innerHTML = text || theme.cart.error_add_cart;
      AT_Main2.triggerDialog(dialog.notify);
    },
    subscribeForm: function() {
      let self2 = this;
      self2.subscribeFail = () => {
        AT_Main2.showNotify(`Could not connect to the registration server. Please try again later.`);
      };
      self2.ajaxMailchimp = (form3) => {
        let url = form3.getAttribute("action"), email = form3.querySelector('input[type="email"]'), ud = `&EMAIL=${encodeURIComponent(email.value)}`;
        if (url == "") {
          self2.subscribeFail();
          return;
        }
        let script = document.createElement("script");
        script.src = url + ud;
        document.body.appendChild(script);
        let callback = "mailchimpCallback";
        window[callback] = function(data) {
          delete window[callback];
          document.body.removeChild(script);
          if (data.result == "success") {
            email.value = "";
            AT_Main2.showNotify(form3.querySelector(".thank_you").innerText || data.msg);
          } else {
            self2.subscribeFail();
          }
        };
      };
      let form2 = [...document.querySelectorAll("form.form-subscribe")];
      form2.length && form2.map((f) => {
        let type = f.getAttribute("data-form-type");
        f.addEventListener("submit", (e) => {
          let url = f.getAttribute("action");
          if (type == "mailchimp") {
            e.preventDefault();
            self2.ajaxMailchimp(f);
          }
          if (type == "klaviyo" && (url == "" || typeof KlaviyoSubscribe == "undefined")) {
            e.preventDefault();
            self2.subscribeFail();
            return;
          }
        });
        if (type == "klaviyo" && typeof KlaviyoSubscribe != "undefined") {
          KlaviyoSubscribe.attachToForms(f, {
            custom_success_message: true,
            success: function($form) {
              let email = $form.find('input[type="email"]');
              email.val("");
              AT_Main2.showNotify($form.find(".thank_you").text());
            }
          });
        }
      });
    },
    initEvents: function() {
      let this2 = this;
      this2.fixReview();
      this2.initDialog();
      this2.subscribeForm();
      this2.clickModal("a[data-target]");
      Shopify.moneyFormat = function(a, b) {
        return formatMoney(a, b);
      };
      document.body.addEventListener("click", function(e) {
        let target = e.target;
        if (document.body.classList.contains("modal-opened")) {
          (target.closest(".ssw-login") != null && target.closest(".ssw-modal-content") == null || target.classList.contains("ssw-close")) && document.body.classList.remove("modal-opened");
        }
      }, true);
      tool_default.addEvent(document, "click", ".sb-btn-show", (e) => {
        e.preventDefault();
        let id2 = e.target.getAttribute("data-target");
        let target = document.querySelector(id2) || null;
        if (target == null) {
          return;
        }
        target.classList.add("active");
        AT_Main2.disablePageScroll(true);
      }, false);
      tool_default.addEvent(document, "click", ".sb-btn-close", (e) => {
        e.preventDefault();
        let id2 = e.target.getAttribute("data-target");
        let target = document.querySelector(id2) || null;
        if (target == null) {
          return;
        }
        target.classList.remove("active");
        AT_Main2.disablePageScroll(false);
      }, false);
      let backToTop = document.querySelector("#backToTop");
      if (tool_default.isExist(backToTop)) {
        backToTop.addEventListener("click", (e) => {
          e.preventDefault();
          AT_Main2.scrollToTop();
        });
        window.addEventListener("scroll", (e) => {
          let scrollTop = window.scrollY;
          if (scrollTop > 100 && scrollTop + window.innerHeight < document.body.clientHeight - 100) {
            backToTop.classList.add("active");
          } else {
            backToTop.classList.remove("active");
          }
        }, { passive: false });
      }
      if (Storage !== void 0) {
        if (document.body.classList.contains("templateCollection")) {
          sessionStorage.collection = theme.collectionLink;
        }
        if (document.querySelector("#continueShopping") != null && typeof sessionStorage.collection != "undefined") {
          document.querySelector("#continueShopping").href = sessionStorage.collection;
        }
      }
      tool_default.addEvent(document, "click", ".btn-language", (e) => {
        e.preventDefault();
        let _this = e.target, lang = _this.getAttribute("data-lang"), returnTo = _this.closest("dialog").getAttribute("data-return"), url = location.origin + lang + returnTo;
        window.location.href = url;
      });
      window.addEventListener("scroll", (e) => {
        let sequenceLazy = document.querySelectorAll(".lazyqueue-wait");
        sequenceLazy.forEach((v, i) => {
          v.classList.add("lazyqueue-active");
        });
      });
      document.body.addEventListener("lazyincludeloaded", (e) => {
        if (e.target.closest(".lazyqueue-wait") != null) {
          e.target.closest(".lazyqueue-wait").classList.remove("lazyqueue-active", "lazyqueue-wait");
        }
      });
      window.addEventListener("load", () => {
        this2.recentView();
        if (window.location.href.includes("shopifypreview")) {
          let target = document.querySelector("#preview-bar-iframe");
          tool_default.isExist(target) && (target.style.display = "none");
          tool_default.debounceTime(1e3, () => {
            document.body.closest("html").style.paddingBottom = null;
          })();
        }
        if (tool_default.getWidthBrowser() < 768) {
          let target = document.querySelector("#admin-bar-iframe");
          tool_default.isExist(target) && (target.style.display = "none");
          tool_default.debounceTime(1e3, () => {
            document.body.closest("html").style.paddingBottom = null;
          })();
        }
      });
      window.addEventListener("resize", () => {
        if (oldWidth == tool_default.getWidthBrowser()) {
          return;
        }
        oldWidth = tool_default.getWidthBrowser();
      });
      tool_default.addEvent(document, "click", "#announcement-bar--close", (e) => {
        e.preventDefault();
        let _parent = e.target.closest("[data-section-type]");
        tool_default.isExist(_parent) && tool_default.fadeOut(_parent);
      });
    },
    init: function() {
      oldWidth = tool_default.getWidthBrowser();
      this.initEvents();
      this.initCountdown();
      this.initCountryProvinceSelector();
      this.resetCollectionPagination();
    }
  };
  var arn_default = AT_Main2;

  // app/scripts/product.js
  register("product", {
    onLoad: function() {
      product_default.init(this.container);
      arn_default.tabPanel_init(this.container);
    }
  });
  function ProductRecommendations(container) {
    var baseUrl = container.dataset.baseUrl;
    var productId = container.dataset.productId;
    var recommendationsSectionUrl = `${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${container.dataset.limit}`;
    window.performance.mark("debut:product:fetch_product_recommendations.start");
    fetch(recommendationsSectionUrl).then(function(response) {
      return response.text();
    }).then(function(productHtml) {
      if (productHtml.trim() === "")
        return;
      let dom = new DOMParser().parseFromString(productHtml.trim(), "text/html");
      let content = container.querySelector(".recommendations-content");
      let contentHTML = content.innerHTML;
      contentHTML += dom.querySelector(".shopify-section").innerHTML;
      content.innerHTML = contentHTML;
      window.performance.mark("debut:product:fetch_product_recommendations.end");
      performance.measure("debut:product:fetch_product_recommendations", "debut:product:fetch_product_recommendations.start", "debut:product:fetch_product_recommendations.end");
      container.style.visibility = null;
      theme.initSlider(container);
    });
  }
  register("recommend-products", {
    onLoad: function() {
      if (this.container.dataset.type == "metafield") {
        theme.initSlider(this.container);
      } else
        ProductRecommendations(this.container);
    }
  });
  load("*");
})();
